import type { WorkflowDefinition } from "@codemation/core";
import { InMemoryLiveWorkflowRepository } from "@codemation/core";
import type { AIAgentConnectionWorkflowExpander } from "@codemation/core-nodes";

export class LiveWorkflowRepository extends InMemoryLiveWorkflowRepository {
  constructor(private readonly connectionExpander: AIAgentConnectionWorkflowExpander) {
    super();
  }

  setWorkflows(workflows: ReadonlyArray<WorkflowDefinition>): void {
    super.setWorkflows(workflows.map((workflow) => this.connectionExpander.expand(workflow)));
  }
}
